import { connect } from "react-redux";
import "./HomepageImaging.css";
import Logo from "../../../Assets/RecliffeImagingHeader.png";
import ImagingLpForm from "./ImagingLpForm";
import { FaPhoneAlt } from "react-icons/fa";
import React, { useState, useEffect, useRef } from "react";
import ImagingHeader from "../ImagingHeader";
import ImagingFooter from "../ImagingFooter";
import TopNav from "../../TopNav/TopNav";
import SubFooter from "../../SubFooter/SubFooter";
import { Scroll } from "../../Scroll function/scroll";
import SimpleForm from "../../chatbot/SimpleForm";
import ScrolltoTop from "../../Scrolltotop/ScrolltoTop";
import Content from "../../../Pages/homePage/Components/Content";
import card1 from "../../../Assets/newAsset/imaging/mri.svg";
import pet from "../../../Assets/newAsset/imaging/pet.svg";
import ct from "../../../Assets/newAsset/imaging/ct.svg";
import ultrasound from "../../../Assets/newAsset/imaging/ultrasound.svg";
import mamory from "../../../Assets/newAsset/imaging/mammography.svg";
import Featured from "../../../Pages/homePage/Components/Featured";
import FAQforhomepage from "../../../Pages/homePage/FAQforhomepage";
import ContactUsNew from "../../../Pages/homePage/Components/ContactUsNew";
import { Modal } from "react-responsive-modal";
import LpForm from "../../../Pages/packageDetailsPage/LpForm";
import miniLogo from "../../../Assets/newAsset/career/minilogo.jpg";
import doc from "../../../Assets/newAsset/imaging/professional-doctor-radiologist-medical-laboratory-1.webp";
import FAQstructure from "../../../Pages/homePage/FAQstructure";
import "../../../Pages/homePage/TestCr.css";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import profile1 from "../../../Assets/newAsset/TestiProfile.webp";
import sam from "../../../Assets/newAsset/imaging/sam.webp";
import { useLocation } from "react-router";

export const Calltoaction = () => {
  const [number, setNumber] = useState();
  useEffect(() => {
    if (window.location.pathname == "/lp/imaging/vl/radiology-services") {
      setNumber("999 053 2654")
    } else {
      setNumber("898 898 0101")
    }
    console.log(window.location.pathname, "window");
  }, []);

  return (
    <div className="stillLookingDiv">
      <div className="lookingDiv1">
        <span className="lookingTitle">Still Looking?</span>
        <span className="lookingSubTitle">
          If you couldn't find what you were looking for, try uploading
          prescription
        </span>
      </div>
      <div className="lookingDiv2">
        {" "}
        <a style={{ color: "#e5184e" }} href={`tel:+91${number}`}>
          <span className="radioLogyBtn">
            <FaPhoneAlt />
            {/* { window.location.pathname == "/lp/imaging/google-vl/radiology-services" ? "999 053 2654" : "898 898 0101"} */}
            {number}
          </span>{" "}
        </a>
      </div>
    </div>
  );
};
export const HomepageImaging = (props) => {
  const [footerTel, setTelNum] = useState("898 898 0101");

  const location = useLocation();

  console.log(location.pathname);

  useEffect(() => {
    if (location.pathname.includes("/ilp/fb")) {
      setTelNum("898 898 0606");
    } else if (location.pathname.includes("/ilp/sms")) {
      setTelNum("898 898 0606");
    } else if (location.pathname.includes("/ilp")) {
      setTelNum("898 898 0606");
    } else {
      setTelNum("898 898 0101");
    }
  }, []);

  //OUR PACKAGES CARDS DATA
  const pacakgesData = [
    {
      id: 1,
      //   img: cross,
      title: "Routine Testing",
      desc: "Routine investigations coverage from wellness to illness",
    },
    {
      id: 2,
      //   img: microscope,
      title: "Pathology Services",
      desc: "Super specialized department to diagnose auto immune disorders",
    },
    {
      id: 3,
      //   img: dna,
      title: "Genomic Testing",

      desc: "Advanced genetic testing to know your health risks",
    },
  ];

  const ImagingTestimonials = [
    {
      id: 1,
      title: "Speedy Report",
      author_name: "Harvinder Kaur ",
      address: false,
      description:
        "I wanted to get the MRI scan done and was looking for reliable and trustworthy imaging services. One of my friends asked me to get in touch with Redcliffe Labs. I can never be happy more than this. They have the best imaging services and highly recommend them. I had a very nice experience as they took care of everything for me. You should certainly try them for your imaging requirements. ",
    },
    {
      id: 2,
      title: "Excellent Service",
      author_name: "Shivam Kumar ",
      address: false,
      description:
        "Redcliffe Labs is one of the best imaging services you can ever find. I was asked to get the MRI scan done by a doctor and I chose them. Trust me, they have got the best team and are highly professional. They never compromise on quality and reports are also delivered within the given time. I would highly recommend their imaging services. ",
    },
    {
      id: 3,
      title: "Prompt Service",
      author_name: "Priya Singla ",
      address: false,
      description:
        "My mother had health issues and after getting in touch with the doctor we got to know that an MRI was needed. So, we got in touch with Redcliffe Labs as one of the relatives had recommended them and we really liked their services. They are very considerate of everything and the best part is we were completely satisfied. I can definitely recommend their services. ",
    },
  ];
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const ImagingFaq = [
    {
      id: 1,
      title: "What is an MRI scan? ",
      desc:
        "MRI or magnetic resonance imaging is non-invasive test doctors recommend for diagnosing medical conditions. It involves using a strong magnetic field, radiofrequency pulses, and a computer for forming detailed pictures of internal body structures. With this imaging test, it becomes easy for the doctor to diagnose and treat any clinical condition. The grouping of gradient coils of the magnetic resonance imaging or MRI device forms substantial vibration and noise. Energetic relations of these phenomena are examined relying on MRI scan parameters like echo time (TE), slice orientation sequence type, repetition time (TR), bodyweight. ",
    },
    {
      id: 2,
      title: "Is MRI risky?",
      desc:
        "MRI uses powerful magnets. Hence, the presence of metal in a patient's body can be a safety hazard if attracted to the magnet. Patients with certain medical conditions like several prosthetic devices, pacemaker implants, cochlear implants, intracranial aneurysm clips, etc. are recommended not to undergo an MRI procedure. ",
    },
    {
      id: 3,
      title: "What are the risks involved with an MRI scan?",
      desc:
        "An MRI scan is known as the secured image diagnostic test currently, thus, there are no severe risks associated with it. ",
    },
    {
      id: 4,
      title: "Difference between CT scans and MRIs? ",
      desc:
        "The use of MRI and CT scans is mostly for similar reasons; the only difference is their functionalities. A CT scan involves using several X-rays for capturing the images of the physiology inner structure, whereas an MRI scan is for the robust magnetic fields and radio waves for achieving the same. Nonetheless, MRI doesn’t involve forming the radiation and is safe than CT scan, and also has the efficiency of delivering more descriptive images.",
    },
    {
      id: 5,
      title: "Should you eat or drink the night before the MRI scan?",
      desc:
        "No, doctors don’t recommend eating or drinking anything before the MRI scan.",
    },
  ];

  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);
  const [home, setHome] = useState(false);

  return (
    <div className="lpImagingMainDiv">
      <div className="lpImagingDiv">
        <div className="imagingLogoDiv">
          <img
            src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/1260204a-0e52-4235-82a0-e3c9fe214c15.webp"
            alt="imaging Logo"
          />
        </div>
        <div className="imagingTwoDiv">
          <div className="imagingDiv1">
            <span className="imagingPackageName">MRI SCAN</span>
            <span className="imagingPara">
              Get Utmost Care With Redcliffe Imaging
            </span>
            <div className="parameterDiv">
              <span className="spanTitle">Types of MRI SCAN:</span>
              <span className="spanDesc">
                Brain MRI Scan | MRI Cervical Scan | MRI Knee | Cardiac MRI |
                Others
              </span>
            </div>
            <div className="imagingLowerDiv">
              <span className="spanTitle2">Starts From </span>
              <div className="spanDescDiv">
                <span className="spanDesC1">₹ 8,000/- </span>
                <span className="spanDesC2"> ₹ 2999/-</span>
              </div>
            </div>
          </div>
          <div className="imagingDiv2">
            {" "}
            <ImagingLpForm push={false} upload={true} />
          </div>
        </div>
      </div>
      <div className="lpImagingMobile">
        <div className="imagingLogoDiv">
          <img
            src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/1260204a-0e52-4235-82a0-e3c9fe214c15.webp"
            alt="imaging Logo"
          />
        </div>
        <div className="imagingTwoDiv">
          <div className="imagingDiv1">
            <span className="imagingPackageName">MRI SCAN</span>
            <span className="imagingPara">
              Get Utmost Care With Redcliffe Imaging
            </span>
            <div className="parameterDiv">
              <span className="spanTitle">Types of MRI SCAN:</span>
              <span className="spanDesc">
                Brain MRI Scan | MRI Cervical Scan | MRI Knee | Cardiac MRI |
                Others
              </span>
            </div>
            <div className="imagingLowerDiv">
              <span className="spanTitle2">Starts From </span>
              <div className="spanDescDiv">
                <span className="spanDesC1">₹ 8,000/- </span>
                <span className="spanDesC2"> ₹ 2999/-</span>
              </div>
            </div>
          </div>
          <div className="imagingDiv2">
            {" "}
            <ImagingLpForm push={false} upload={true} />
          </div>
        </div>
      </div>
      <Modal open={open} onClose={onCloseModal} center>
        <LpForm
          butname={"SUBMIT"}
          title={"Book Your Test"}
          position={"Banner"}
          isImagine={true}
        />
      </Modal>
      {/**OUR PACKAGES  */}
      <div className="imagine_Ourpackage">
        <div className="parentDivImagine">
          <div className="imagine_heading">
            <h2 className="textPink">Our Services</h2>
            <span>All Imaging Services Under One Roof</span>
          </div>
          <div className="mobileImagineDiv">
            <div className="imagineCardRow">
              <div className="cardImagine">
                <img src={card1} />
                <span className="textBlue">MRI Scan</span>
              </div>
              <div className="cardImagine">
                <img src={pet} />
                <span className="textBlue">PET Scan</span>
              </div>

              <div className="cardImagine">
                <img src={ct} />
                <span className="textBlue">CT Scan</span>
              </div>

              <div className="cardImagine">
                <img src={ultrasound} />
                <span className="textBlue">Ultrasound</span>
              </div>

              <div className="cardImagine">
                <img src={mamory} />
                <span className="textBlue">Mammography</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/**Testimonial */}

      {/* <Content title="Testimonials" Ispackage={false} static={true} testiArray={ImagingTestimonials} isTestimonial={true} /> */}
      <div className="imagingTest">
        <div className="parentDiv  ">
          <div className="childDiv container">
            <div className="HeaderDiv">
              <div className="divHeading">
                <h2>Testimonials</h2>
                <p> </p>
              </div>
            </div>
            <Carousel
              swipeable={true}
              draggable={false}
              showDots={false}
              responsive={responsive}
              ssr={true} // means to render carousel on server-side.
              infinite={true}
              autoPlay={false}
              autoPlaySpeed={2500}
              transitionDuration={200}
              deviceType={"tablet"}
            >
              {ImagingTestimonials.map((value) => {
                return (
                  <div className="testimonial" key={value.id}>
                    <div className="testimonial__card">
                      <div className="testimonial__cardHeader">
                        <img src={profile1} alt="Profile logo"></img>
                        <div className="card__headerUserDetails">
                          <span>
                            {value.title ? (
                              <span>{value.author_name}</span>
                            ) : (
                              <span>nothing</span>
                            )}
                          </span>
                          <span>
                            {value.address ? (
                              <span>
                                {value.address}, {value.age}
                              </span>
                            ) : (
                              <span> </span>
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="testimonial__cardTitle">
                        <span>"{value.title}"</span>
                      </div>
                      <div className="testimonial__cardFooter">
                        <span>
                          <div>{value.description}</div>
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </Carousel>
          </div>
        </div>
      </div>
      {/**RadoilogyDiv */}
      <Calltoaction />
      {/**FAQ */}
      <div className="accordionNew">
        {home ? (
          <h2 className="h1style"> FAQs</h2>
        ) : (
          <h2 className="h1style"> Frequently Asked Questions</h2>
        )}

        {console.log("screen size ")}
        {ImagingFaq.map((value, index) => (
          <div key={value.id}>
            <FAQstructure value={value} />
          </div>
        ))}
      </div>
      <ScrolltoTop />
      <div className="chatbot">
        <SimpleForm />
      </div>
      <ImagingFooter noFaq={true} telNumber={footerTel} screen={home} />
      <div className="SubFooterWrapper">
        <button>
          <a style={{ color: "#e5184e" }} href={`tel:+918988980101`}>
            call now
          </a>
        </button>
        <button
          onClick={onOpenModal}
          style={{ color: "#fff", fontWeight: "600" }}
        >
          Book Now
        </button>

        {/* <ScrolltoTop /> */}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default {
  component: connect(
    mapStateToProps,
    mapDispatchToProps
  )(React.memo(HomepageImaging)),
};
